var slidedownVideoPlayer = slidedownVideoPlayer || {};

(function ($) {
  // @todo post launch - get this to work inside the bahavior
  var $videoPlayers = $('body').find('.js-slidedown-video-player');

  $videoPlayers.each(function () {
    var $player = $(this);

    $(document).bind('youtubeIframeAPI.loaded', function (e) {
      slidedownVideoPlayer.setup(e, $player);
    });
  });
})(jQuery);
